//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import storage from '../lib/storage'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import SignturePad from '../components/signaturePad'

export default {
  components: { SignturePad },
  data() {
    return {
      userName: 'DST',
      realName: 'DST',
      versions: '',
      cacheSize: '0.0M',
      point: '',
      signPicker: false,
      headStyle: {
        background: '#fff',
        color: '#333333',
        borderBottom: '1px solid #F3F6F7',
        fontWeight: '500'
      },
      signConfig: {
        data: {
          relationDataType: 'deliveryCar',
          relationDataPoint: 'autograph'
        },
        postUrl: this.$api.uploadSignature,
        save: 'my'
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', '_signData'])
  },
  mounted() {
    this.cacheSize = webBridge.getCacheSize() || '0.0M'
    // APP 绑定方法
    this.userName = storage.get('_userInfo').username
    this.realName = storage.get('_userInfo').realname
    this.getSign()
    this.getVersions()
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    ...mapActions(['getSign']),
    checkVersions() {
      webBridge.checkUpdate()
    },
    logoutApp() {
      this.postAjax(this.$api.clearCid, {})
        .then(async res => {
          await this.$axios({
            url: `/dst-apis/sso/logout`,
            method: 'post',
            baseURL: ''
          })
          webBridge.logoutApp()
        })
    },
    back() {
      webBridge.onBackPressed()
    },
    link(url) {
      this.$router.push(url)
    },
    getVersions() {
      this.versions = webBridge.getVersionName()
      webBridge.getUpdateRedDotStatus()
        .then(res => {
          this.point = res
        })
    },
    clearCache() {
      webBridge.clearH5Cache()
      this.cacheSize = '0.0M'
    },
    postAjax(url, data) {
      return new Promise((resolve, reject) => {
        this.$axios.post(url, data).then(res => {
          if (res.code === 0) {
            resolve(res)
          } else {
            this.$vux.toast.show(res.msg)
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/my.vue